import React from 'react';
import PropTypes from 'prop-types';

import { Dialog, DialogType } from '@fluentui/react/lib/Dialog';
import { useElementViewed } from '@bingads-webui-campaign-react/smart-component-util';
import { useInstrumentationServiceContext } from '@bingads-webui-campaign-react/smart-page-context';

import { PrivacyContent } from './privacy-content';

const getDialogContentStyle = isMobile => ({
  title: {
    fontSize: 24,
    padding: 20,
    lineHeight: '28px',
    textAlign: 'center',
  },
  inner: {
    margin: isMobile ? 0 : '20px 50px 40px',
  },
});

export const PrivacyContentDialog = ({
  value,
  businessName,
  onClose,
  i18n,
  isMobile,
}) => {
  const logger = useInstrumentationServiceContext();
  useElementViewed(logger, 'RuntimePrivacyDialog');

  return (
    <Dialog
      hidden={false}
      onDismiss={onClose}
      minWidth="360px"
      maxWidth={isMobile ? '360px' : '1030px'}
      dialogContentProps={{
        type: DialogType.close,
        title: i18n.getString(_TL_('Privacy policies')),
        styles: getDialogContentStyle(isMobile),
      }}
      modalProps={{
        isBlocking: true,
        className: 'privacy-content-dialog',
      }}
    >
      <PrivacyContent value={value} businessName={businessName} i18n={i18n} />
    </Dialog>
  );
};

PrivacyContentDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  businessName: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

